import React from "react";
import { Box } from "@mui/material";

const Orders = () => {
  return (<Box className="px-5 py-3">Orders</Box>);
};

export default Orders;